export default {"src":"/_next/static/image/public/images/ic_bookmark_checked.9b0cc16080fff8ecfe0341b5b57ebae3.svg","height":19,"width":19};